import { Component, OnInit, Input, OnDestroy, ChangeDetectorRef, AfterViewInit, ViewChild } from '@angular/core';
import { LazyLoadEvent, MessageService } from 'primeng/api';
import { ConfigService } from 'app/services';
import { Utils } from 'app/utils';
import { StylesStatus } from 'app/models/users/StylesStatus';
import * as moment from 'moment/moment';
import {PayoutTransactionStatusEnum} from 'app/models/transaction/payout-transaction-status.enum';
import {MenuHomeEnum} from 'app/home';
import {MenuService} from 'app/finance/finance-payout/menu-service';
import {Subscription} from 'rxjs';
import {CebuanaPayoutTransactionService} from 'app/services/cebuana-payout-transaction.service';
import {EditTableConfig} from 'app/models/configs/edit-table-config';
import {ColumnSelectorComponent} from 'app/column-selector/column-selector.component';
import { FieldTypeEnum } from 'app/models';
import { TableLazyLoadEvent } from 'primeng/table';

@Component({
    selector: 'finance-payout-cebuana',
    templateUrl: './finance-payout-cebuana.component.html',
    styleUrls: ['./finance-payout-cebuana.component.scss',
        '../../../../../styles/paginator.scss'],
    providers: [MessageService]
})

export class FinancePayoutCebuanaComponent implements OnInit, OnDestroy, AfterViewInit {
    @Input()
    public menuPermissionActive!: string;

    @Input()
    public onboardingTabMenu: Array<any> = [];

    @ViewChild(ColumnSelectorComponent)
    public columnSelector!: ColumnSelectorComponent;

    payoutTransactions: Array<any> = [];
    arrayFilterStatuses: any =
        [
            { name: 'All', value: null },
            { name: 'Pending', value: PayoutTransactionStatusEnum.Pending },
            { name: 'Processing', value: PayoutTransactionStatusEnum.Processing },
            { name: 'Completed', value: PayoutTransactionStatusEnum.Completed }
        ];
    cols: any[] = [
        {
            field: 'Id',
            header: 'TX ID',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'Id',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'CreatedAt',
            header: 'Transaction Date',
            width: '10%',
            fieldType: FieldTypeEnum.Calendar,
            model: 'CreatedAt',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'RiderId',
            header: 'Driver ID',
            width: '10%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'RiderId',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'FirstName',
            header: 'First Name',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'FirstName',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'LastName',
            header: 'Last Name',
            width: '10%',
            fieldType: FieldTypeEnum.Inputs,
            model: 'LastName',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'Amount',
            header: 'Amount',
            width: '20%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'Amount',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'Cellphone',
            header: 'Cellphone',
            width: '20%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'Cellphone',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'ProcessedAt',
            header: 'Date Processed',
            width: '20%',
            fieldType: FieldTypeEnum.Calendar,
            model: 'ProcessedAt',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'ControlNumber',
            header: 'Control No.',
            width: '20%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'ControlNumber',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'BranchCode',
            header: 'Branch Code',
            width: '20%',
            fieldType: FieldTypeEnum.InputNumber,
            model: 'BranchCode',
            placeholder: 'Type here',
            active: false
        },
        {
            field: 'StatusName',
            header: 'Status',
            width: '20%',
            disableSort: false,
            fieldType: FieldTypeEnum.Dropdown,
            model: 'StatusName',
            options: this.arrayFilterStatuses,
            placeholder: 'Please Select',
            active: false,
            action: (rowData: any) => this.getStatusStyles(rowData)
        },
        {
            field: 'PaidAt',
            header: 'Date Paid',
            width: '20%',
            fieldType: FieldTypeEnum.Calendar,
            model: 'PaidAt',
            placeholder: 'Type here',
            active: false
        }
    ];
    public defaultCols = this.cols.map(x => x);

    rowsPerPage: number = 10;
    totalRecords: number = -1;
    exportHeaderColumns: string[] = [];
    exportDataColumns: string[] = [];
    fieldTypeEnum = FieldTypeEnum;
    paginator: Paginator = new Paginator();
    visibleTransactionsFilter: boolean = false;
    visibleTransactionsSettings: boolean = false;
    filterObj: any = {
        startDate: null,
        endDate: null,
        digitType: null,
        payService: null
    };
    txnHeaderSearch: any = {
        id: null,
        createdAt: null,
        riderId: null,
        firstName: null,
        lastName: null,
        amount: null,
        cellphone: null,
        processedAt: null,
        paidAt: null,
        controlNumber: null,
        branchCode: null,
        status: null,
    };
    first: number = 0;
    sortField: string | string[] = 'Id';
    sortOrder: number = -1;
    loading: boolean = false;
    searchTimer: number = 0;
    showDetailTransactionSidebar: boolean = false;
    selectedTransaction: any;
    menuHomeEnumActive: MenuHomeEnum | undefined;
    $subscription: Subscription | undefined;

    tableName: string = EditTableConfig.FINANCE_PAYOUT_CEBUANA;
    selectedColumns: any[] = [];

    constructor(
        private messageService: MessageService,
        private payoutTransactionService: CebuanaPayoutTransactionService,
        public configService: ConfigService,
        private menuService: MenuService,
        private cdRef: ChangeDetectorRef) {
        this.handleHideTransactionInfo = this.handleHideTransactionInfo.bind(this);
    }

    ngOnInit(): void {
        this.$subscription = this.menuService.menuHomeEnumActive$.subscribe(
            (value) => {
                this.menuHomeEnumActive = value;
            }
        );
    }

    ngAfterViewInit(): void {
        this.cdRef.detectChanges();
    }

    ngOnDestroy(): void {
        this.$subscription?.unsubscribe();
    }

    onSelectedColumnsChange(event: any[]) {
        if (event && event.length > 0) {
            this.selectedColumns = event;
        }
        else {
            this.selectedColumns = this.cols;
        }

        this.exportHeaderColumns = this.selectedColumns.map(x => x.header);
        this.exportDataColumns = this.selectedColumns.map(x => x.field);
    }

    getMenuHomeName(): string {
        return this.onboardingTabMenu.find((item: any) => item.value === this.menuHomeEnumActive).name;
    }

    handleLazyLoad(event: TableLazyLoadEvent): void {
        const skip = event.first ? event.first : 0;

        if (event.rows) {
            this.rowsPerPage = event.rows;
        }

        if (!event.sortField) {
            this.sortField = 'Id';
            this.sortOrder = -1; // Desc
        }
        else {
            this.sortField = event.sortField;
            this.sortOrder = event.sortOrder ? event.sortOrder : 1;
        }

        if (this.columnSelector) {
            this.columnSelector.loadTableSettings(this.tableName);
        }

        this.callGridTitles(skip);
    }

    filter: {
        searchName: string;
    } = { searchName: '' };

    handleFilterChange(model: string, event: any): void {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            if (model === 'Id') {
                this.txnHeaderSearch.id = event.target.value;
            }
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    handleHeaderFilterChange() {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }
        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1500);
    }

    getPayoutTransactions(skip: number) {
        const dto = {
            SearchName: this.filter.searchName,
            Id: this.txnHeaderSearch.id ? this.txnHeaderSearch.id : null,
            CreatedAt: this.txnHeaderSearch.CreatedAt ? this.txnHeaderSearch.CreatedAt : null,
            RiderId: this.txnHeaderSearch.RiderId ? this.txnHeaderSearch.RiderId : null,
            FirstName: this.txnHeaderSearch.FirstName ? this.txnHeaderSearch.FirstName : null,
            LastName: this.txnHeaderSearch.LastName ? this.txnHeaderSearch.LastName : null,
            Amount: this.txnHeaderSearch.Amount ? this.txnHeaderSearch.Amount : null,
            PaidAt: this.txnHeaderSearch.PaidAt ? this.txnHeaderSearch.PaidAt : null,
            ProcessedAt: this.txnHeaderSearch.ProcessedAt ? this.txnHeaderSearch.ProcessedAt : null,
            Status: this.txnHeaderSearch.StatusName ? this.txnHeaderSearch.StatusName : null,
            Cellphone: this.txnHeaderSearch.Cellphone ? this.txnHeaderSearch.Cellphone+'' : null,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            Skip: skip,
            Take: this.rowsPerPage,
            SortField: this.sortField,
            SortOrder: this.sortOrder
        };
        this.loading = true;
        this.payoutTransactionService.getPayoutTransactions(dto, this.messageService)
            .then(data => {
                this.loading = false;
                if (!data.Success) {
                    this.messageService.add({ severity: 'error', summary: 'Error', detail: data.ErrorMessage });
                    return;
                }
                this.first = dto.Skip;
                this.totalRecords = data.TotalRecords;
                this.paginator.Items = [];
                this.paginator.Items.push(...data.Transactions);
                this.payoutTransactions = this.formatPayOutTransactions(data.Transactions);
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }

    formatPayOutTransactions(transactions: any): any {
        transactions.map((item: any) => {
            item.CreatedAt = moment(Utils.utcToLocaleString(item.CreatedAt)).format('DD MMM yyyy hh:mm');
            item.ProcessedAt = item.ProcessedAt ? moment(Utils.utcToLocalDate(item.ProcessedAt)).format('DD MMM yyyy hh:mm') : '';
            item.PaidAt = item.PaidAt ? moment(Utils.utcToLocalDate(item.PaidAt)).format('DD MMM yyyy hh:mm') : '';
            return item;
        });
        return transactions;
    }

    clickChangeMenuHomeActive(value: MenuHomeEnum) {
        this.menuService.changeMenuHomeEnumActive(value);
        this.handleLazyLoad({
            first: 0,
            rows: this.rowsPerPage
        });
    }

    getStatusName(status: number): string {
        return this.arrayFilterStatuses.find((item: any) => item.value === status).name;
    }

    getStatusStyles(item: any): StylesStatus {
        let backgroundColor: string;
        let textColor: string;
        switch (item.Status) {
            case PayoutTransactionStatusEnum.Completed:
                backgroundColor = '#E7F7EF';
                textColor = '#1CBA70';
                break;
            case PayoutTransactionStatusEnum.Pending:
                backgroundColor = '#FFEFCC';
                textColor = '#FFB100';
                break;
            case PayoutTransactionStatusEnum.Processing:
                backgroundColor = '#FDEBEA';
                textColor = '#EB4236';
                break;
            default:
                backgroundColor = '';
                textColor = '';
        }

        return {
            backgroundColor,
            color: textColor
        };
    }

    onSelectionChange(event: any) {
        this.selectedTransaction = event?.data;
    }

    handleHideTransactionInfo() {
        this.showDetailTransactionSidebar = false;
    }

    handleShowTransactionInfo(transaction: any) {
        this.selectedTransaction = transaction;
        this.showDetailTransactionSidebar = true;
    }

    callGridTitles(skip: number) {
        this.callPayoutTransactions(skip);
    }

    callPayoutTransactions(skip: number) {
        this.getPayoutTransactions(skip);
    }
    onChangeHeaderFilterDropDown(model: string, event: any) {
        if (this.searchTimer) {
            window.clearTimeout(this.searchTimer);
        }

        this.searchTimer = window.setTimeout(() => {
            this.callGridTitles(0);
            this.searchTimer = 0;
        }, 1000);
    }

    openTransactionsFilter() {
        this.visibleTransactionsFilter = !this.visibleTransactionsFilter;
    }

    openTransactionsSettings() {
        this.visibleTransactionsSettings = !this.visibleTransactionsSettings;
    }

    changedVisibleHomeTransactionsFilterEmit(event: { increased: boolean; reason: string }) {
        this.visibleTransactionsFilter = event.increased;
        if (event.reason) {
            this.messageService.add({ severity: 'success', summary: 'Success', detail: event.reason });
            this.callGridTitles(0);
        }
    }

    updateEventEmit(value: any) {
        this.callGridTitles(0);
    }

    changedVisibleTransactionsSettingsEmit(value: any) {
        this.visibleTransactionsSettings = value;
    }

    onDownloadClick(): void {
        const dto = {
            SearchName: this.filter.searchName,
            Id: this.txnHeaderSearch.id ? this.txnHeaderSearch.id : null,
            CreatedAt: this.txnHeaderSearch.createdAt ? moment(this.txnHeaderSearch.createdAt).format('YYYY-MM-DDTHH:mm:ss') : null,
            RiderId: this.txnHeaderSearch.riderId ? this.txnHeaderSearch.riderId : null,
            FirstName: this.txnHeaderSearch.firstName ? this.txnHeaderSearch.firstName : null,
            LastName: this.txnHeaderSearch.lastName ? this.txnHeaderSearch.lastName : null,
            Amount: this.txnHeaderSearch.amount ? this.txnHeaderSearch.amount : null,
            Status: this.txnHeaderSearch.status ? this.txnHeaderSearch.status : null,
            Cellphone: this.txnHeaderSearch.cellphone ? this.txnHeaderSearch.cellphone : null,
            TimeZoneOffset: Utils.getTimezoneOffset(),
            SortField: this.sortField,
            SortOrder: this.sortOrder,
            HeaderColumns: this.exportHeaderColumns,
            DataColumns: this.exportDataColumns
        };
        this.loading = true;
        this.payoutTransactionService.downloadPayoutTransactions(dto, this.messageService)
            .then(data => {
                this.loading = false;
                Utils.saveFileResponse(data, 'Cebuana-Payout-' + new Date().valueOf() + '.xlsx');
            })
            .catch(err => {
                this.loading = false;
                throw err;
            });
    }
}

class Paginator {
    public Loading: boolean = true;
    public TotalRecords: number = 0;
    public Items: Array<any> = [];
    public Skip: number = 0;
    public Take: number = 10;
}
